// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Faq/Faq.css
// module id = 727
// module chunks = 1